export enum DRC_METHOD {
  HEART_BEAT = 'heart_beat',
  DRONE_CONTROL = 'drone_control', // 비행 제어 - 가상 조이스틱
  DRONE_EMERGENCY_STOP = 'drone_emergency_stop', // 비상 정지
  OSD_INFO_PUSH = 'osd_info_push', // 고주파 OSD 정보 보고
  HSI_INFO_PUSH = 'hsi_info_push', // 장애물 회피 정보 보고
  DELAY_TIME_INFO_PUSH = 'delay_info_push', // 영상 전송 링크 지연 정보 보고
}

// 수동 제어
export interface DroneControlProtocol {
  x?: number; // 수평 방향 속도. 양수 값은 A 명령, 음수 값은 D 명령. 단위: m/s
  y?: number; // 전후진 방향 속도. 양수 값은 W 명령, 음수 값은 S 명령. 단위: m/s
  h?: number;// 상하 고도 값. 양수 값은 상승 명령, 음수 값은 하강 명령. 단위: m
  w?: number; // 기수 각속도. 양수 값은 시계 방향, 음수 값은 시계 반대 방향. 단위: degree/s (웹 버전 미지원)
  seq?: number; // 0부터 시작
}

// 저지연 OSD
export interface DRCOsdInfo {
  attitude_head: number;// 드론 자세 헤딩 각도. 단위: 도
  latitude: number;// 드론 위도/경도
  longitude: number;
  altitude: number;
  speed_x: number;
  speed_y: number;
  speed_z: number;
  gimbal_pitch: number;// 짐벌 피치 각도
  gimbal_roll: number;// 짐벌 롤 각도
  gimbal_yaw: number;// 짐벌 요 각도
}

// 상황 인지 - HSI
export interface DRCHsiInfo {
  up_distance: number;// 상단 장애물 거리. 단위: mm
  down_distance: number;// 하단 장애물 거리. 단위: mm
  around_distances: number[]; // 수평 방향 관측 지점. [0, 360) 구간에 분포하며 드론과 장애물 간의 거리를 나타냄. 단위: mm. 0은 기수 정면 기준이며 시계 방향으로 분포함 (예: 0도는 기수 정면, 90도는 드론 오른쪽)
  up_enable: boolean; // 상향 장애물 회피 스위치 상태. true: 켜짐, false: 꺼짐
  up_work: boolean; // 상향 장애물 회피 작동 상태. true: 정상 작동, false: 이상 또는 오프라인
  down_enable: boolean; // 하향 장애물 회피 스위치 상태. true: 켜짐, false: 꺼짐
  down_work: boolean; // 하향 장애물 회피 작동 상태. true: 정상 작동, false: 이상 또는 오프라인
  left_enable: boolean; // 좌측 장애물 회피 스위치 상태. true: 켜짐, false: 꺼짐
  left_work: boolean; // 좌측 장애물 회피 작동 상태. true: 정상 작동, false: 이상 또는 오프라인
  right_enable: boolean; // 우측 장애물 회피 스위치 상태. true: 켜짐, false: 꺼짐
  right_work: boolean; // 우측 장애물 회피 작동 상태. true: 정상 작동, false: 이상 또는 오프라인
  front_enable: boolean; // 전면 장애물 회피 스위치 상태. true: 켜짐, false: 꺼짐
  front_work: boolean; // 전면 장애물 회피 작동 상태. true: 정상 작동, false: 이상 또는 오프라인
  back_enable: boolean; // 후면 장애물 회피 스위치 상태. true: 켜짐, false: 꺼짐
  back_work: boolean; // 후면 장애물 회피 작동 상태. true: 정상 작동, false: 이상 또는 오프라인
  vertical_enable: boolean; // 수직 방향 통합 스위치 상태. 상하향 스위치가 모두 true일 때 true(켜짐), 그렇지 않으면 false(꺼짐)
  vertical_work: boolean; // 수직 방향 장애물 회피 작동 상태. 상하향 작동 상태가 모두 true일 때 true(정상 작동), 그렇지 않으면 false(이상 또는 오프라인)
  horizontal_enable: boolean; // 수평 방향 통합 스위치 상태. 전후좌우 스위치가 모두 true일 때 true(켜짐), 그렇지 않으면 false(꺼짐)
  horizontal_work: boolean; // 수평 방향 장애물 회피 작동 통합 상태. 전후좌우 작동 상태가 모두 true일 때 true(정상 작동), 그렇지 않으면 false(이상 또는 오프라인)
}

export interface LiveViewDelayItem {
  video_id: string;
  liveview_delay_time: number;
}

// 링크 지연 정보
export interface DRCDelayTimeInfo {
  sdr_cmd_delay: number; // SDR 링크 명령 지연. 단위: ms
  liveview_delay_list: LiveViewDelayItem[];
}

export interface DrcResponseInfo {
  result: number;
  output: {
    seq: number
  }
}
